import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-696c728c")

_pushScopeId("data-v-696c728c")
const _hoisted_1 = { class: "shell height90per" }
const _hoisted_2 = { class: "customer-service" }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "placeholder" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("b", null, _toDisplayString(_ctx.$wordList.ProperAllTextCustomerService), 1),
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("label", null, _toDisplayString(_ctx.$wordList.TabelPersonUserInHtmlPhone), 1),
        _createVNode(_component_el_input, {
          modelValue: _ctx.phone,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.phone = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("label", null, _toDisplayString(_ctx.$wordList.TabelPropertyManageEmail), 1),
        _createVNode(_component_el_input, {
          modelValue: _ctx.email,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event))
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_6
    ]),
    _createVNode(_component_cus_button, {
      type: "blue",
      class: "save-button",
      onClick: _ctx.submit
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSave), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
})